<template>
  <ul class="menu-nav">
    <template v-for="(breadcrumb, i) in breadcrumbs">

      <router-link :to="`${breadcrumb.route}`"
                   v-slot="{ href, navigate, isActive, isExactActive }">
        <li aria-haspopup="true"
            data-menu-toggle="hover"
            class="menu-item"
            :class="[ isActive && 'menu-item-active', isExactActive && 'menu-item-active']">
          <a :href="href"
             class="menu-link"
             @click="navigate"
             v-if="href!=='/undefined'">
            <span class="menu-text"> {{ $t(breadcrumb.title) }} </span>
          </a>
          <a class="menu-link"
             v-else>
            <span class="menu-text"> {{ $t(breadcrumb.title) }} </span>
          </a>
        </li>
      </router-link>
    </template>

    <!-- <router-link to="/dashboard"
                 v-slot="{ href, navigate, isActive, isExactActive }">
      <li aria-haspopup="true"
          data-menu-toggle="hover"
          class="menu-item"
          :class="[
          isActive && 'menu-item-active',
          isExactActive && 'menu-item-active',
        ]">
        <a :href="href"
           class="menu-link"
           @click="navigate">
          <span class="menu-text">Dashboard</span>
        </a>
      </li>
    </router-link> -->
  </ul>
</template>

<script>
export default {
  name: 'KTMenu',
  props: {
    breadcrumbs: Array,
  },
  methods: {
    // hasActiveChildren(match) {
    //   return this.$route["path"].indexOf(match) !== -1;
    // }
  },
}
</script>
